import React from 'react';
import TextInput from "./";
import AuthService from "../../../../services/AuthService";

export default class ReceiptTextInput extends React.Component {
    truncate = (name, val) => {
        const lengths = {
            storeId: 3,
            posId: 1,
            receiptId: 4,
        };
        return val.substr(0, lengths[name]);
    };

    handleInput = (e) => {
        const parts = this.getReceiptParts(this.props.value);
        parts[e.target.name] = this.truncate(e.target.name, e.target.value);

        this.props.onChange({
            target: {
                name: this.props.name,
                value: this.makeReceiptNumber(parts),
                type: 'text'
            }
        });
    };

    makeReceiptNumber = ({ storeId, posId, receiptId }) => [storeId, posId, receiptId].join('/');

    getReceiptParts = (val) => {
        const tokens = val.split('/');
        const storeId = tokens[0] || '';
        const posId = tokens[1] || '';
        const receiptId = tokens[2] || '';
        return {
            storeId,
            posId,
            receiptId,
        };
    };

    render() {
        const { storeId, posId, receiptId } = this.getReceiptParts(this.props.value);
        const storeIdWrapperClass = (this.props.canEditStoreId) ? 'col col--tiny' : 'col';
        return (
            <div className="col">
                <label htmlFor="receiptId" className="sub-title text--grey">{this.props.label}</label>
                {this.props.tooltip}
                <div className="gutter--15 receipt-number">
                    <div className={storeIdWrapperClass} key="storeId">
                        {
                            this.props.canEditStoreId ?
                            <TextInput
                                name="storeId"
                                value={storeId}
                                placeholder="0"
                                required={this.props.required}
                                onChange={this.handleInput}
                            /> :
                            <span className="storeId">{storeId}</span>
                        }
                    </div>
                    <span className="divider">/</span>
                    <div className="col col--tiny" key="posId">
                        <TextInput
                            name="posId"
                            value={posId}
                            placeholder="0"
                            required={this.props.required}
                            onChange={this.handleInput}
                        />
                    </div>
                    <span className="divider">/</span>
                    <div className="col col--tiny" key="receiptId">
                        <TextInput
                            id="receiptId"
                            name="receiptId"
                            placeholder="0000"
                            value={receiptId}
                            required={this.props.required}
                            onChange={this.handleInput}
                        />
                    </div>
                </div>
                {this.props.error && <span className="error text--red">{this.props.error}</span>}
                {!this.props.error && this.props.warning && <span className="error text--warning">{this.props.warning}</span>}
            </div>
        );
    } 
}
